// extracted by mini-css-extract-plugin
export default {"cardActions":"SimpleIconButton_cardActions__u1qgU","wrapper":"SimpleIconButton_wrapper__+CGNl"};